import React from 'react';
import styled from 'styled-components';
import { useTheme } from '@context/ThemeContext';

interface ThemeToggleProps {
  iconSize?: 'small' | 'medium' | 'large';
  showContainer?: boolean;
  lightIcon?: string;
  darkIcon?: string;
  showThemeText?: boolean;
}

const Container = styled.div<{ theme: string }>`
  padding: 2rem;
  border-radius: 8px;
  transition: all 0.3s ease;
  background-color: ${props => props.theme === 'dark' ? '#1F2937' : '#F3F4F6'};
  color: ${props => props.theme === 'dark' ? '#ffffff' : '#000000'};
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  box-shadow: 0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -1px rgba(0, 0, 0, 0.06);
`;

const ToggleButton = styled.button<{ theme: string; $iconSize: string }>`
  background: none;
  border: none;
  cursor: pointer;
  padding: ${props => {
    switch (props.$iconSize) {
      case 'small': return '4px';
      case 'large': return '12px';
      default: return '8px';
    }
  }};
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.3s ease;
  
  &:hover {
    background-color: ${props => props.theme === 'dark' ? 'rgba(255, 255, 255, 0.1)' : 'rgba(0, 0, 0, 0.1)'};
    transform: scale(1.1);
  }
`;

const Icon = styled.span<{ theme: string; $iconSize: string }>`
  font-size: ${props => {
    switch (props.$iconSize) {
      case 'small': return '1rem';
      case 'large': return '2rem';
      default: return '1.5rem';
    }
  }};
  color: ${props => props.theme === 'dark' ? '#fff' : '#000'};
`;

const ThemeText = styled.p<{ theme: string }>`
  margin: 0;
  font-size: 1rem;
  color: ${props => props.theme === 'dark' ? '#fff' : '#000'};
`;

export const ThemeToggle: React.FC<ThemeToggleProps> = ({
  iconSize = 'medium',
  showContainer = true,
  lightIcon = '☀️',
  darkIcon = '🌙',
  showThemeText = true
}) => {
  const { theme, toggleTheme } = useTheme();

  const content = (
    <>
      <ToggleButton onClick={toggleTheme} theme={theme} $iconSize={iconSize}>
        <Icon theme={theme} $iconSize={iconSize}>
          {theme === 'dark' ? lightIcon : darkIcon}
        </Icon>
      </ToggleButton>
      {showThemeText && (
        <ThemeText theme={theme}>
          Tema actual: {theme === 'dark' ? 'Oscuro' : 'Claro'}
        </ThemeText>
      )}
    </>
  );

  if (showContainer) {
    return (
      <Container theme={theme === 'dark' ? 'dark' : 'light'}>
        {content}
      </Container>
    );
  }

  return content;
}; 